// extracted by mini-css-extract-plugin
export default {"container":"sM-z","topReviewHeading":"tM-z","criticalReview":"uM-z","favorableReview":"vM-z","vsSeparator":"wM-z"};